import React, { Component } from 'react';

export default class Row extends Component {
  state = {  }
  render() { 
    return (  
      <div className='row'>
        {this.props.children}
      </div>
    );
  }
}
